<template>
  <aside class="admin-sidebar" :class="{ 'is-open': mobileOpen, 'is-collapsed': collapsed }">
    <div class="admin-sidebar__brand">
      <div class="admin-sidebar__brand-mark">
        <span class="admin-sidebar__brand-play"></span>
      </div>
      <div v-if="!collapsed" class="admin-sidebar__brand-text">
        <div class="admin-sidebar__brand-title">直播智控云</div>
      </div>
    </div>

    <nav class="admin-sidebar__nav">
      <component
        v-for="item in items"
        :key="item.key"
        :is="item.href ? 'a' : 'router-link'"
        v-bind="navItemAttrs(item)"
        class="admin-sidebar__item"
        :class="{ 'is-active': item.key === activeKey }"
        :title="collapsed ? item.label : ''"
        @click.native="$emit('navigate')"
      >
        <span class="admin-sidebar__icon" aria-hidden="true">
          <svg v-if="item.icon === 'grid'" viewBox="0 0 24 24">
            <rect x="4" y="4" width="6" height="6" rx="1.5" />
            <rect x="14" y="4" width="6" height="6" rx="1.5" />
            <rect x="4" y="14" width="6" height="6" rx="1.5" />
            <rect x="14" y="14" width="6" height="6" rx="1.5" />
          </svg>
          <svg v-else-if="item.icon === 'pulse'" viewBox="0 0 24 24">
            <path d="M3 12h4l2.2-6 4.1 12 2.1-6H21" />
          </svg>
          <svg v-else-if="item.icon === 'chart'" viewBox="0 0 24 24">
            <path d="M4 20V8" />
            <path d="M10 20V4" />
            <path d="M16 20v-9" />
            <path d="M22 20v-5" />
            <path d="M3 20h20" />
          </svg>
          <svg v-else-if="item.icon === 'gear'" viewBox="0 0 24 24">
            <path d="M12 8.2a3.8 3.8 0 1 1 0 7.6 3.8 3.8 0 0 1 0-7.6Z" />
            <path d="m19.4 15-.8 1.8 1 2-1.9 1.9-2-1-1.8.8-.7 2.1h-2.6l-.7-2.1-1.8-.8-2 1-1.9-1.9 1-2-.8-1.8-2.1-.7v-2.6l2.1-.7.8-1.8-1-2 1.9-1.9 2 1 1.8-.8.7-2.1h2.6l.7 2.1 1.8.8 2-1 1.9 1.9-1 2 .8 1.8 2.1.7v2.6z" />
          </svg>
          <svg v-else-if="item.icon === 'layers'" viewBox="0 0 24 24">
            <path d="m12 4 8 4-8 4-8-4 8-4Z" />
            <path d="m4 12 8 4 8-4" />
            <path d="m4 16 8 4 8-4" />
          </svg>
          <svg v-else-if="item.icon === 'message'" viewBox="0 0 24 24">
            <path d="M5 6h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9l-4 3v-3H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z" />
          </svg>
          <svg v-else-if="item.icon === 'megaphone'" viewBox="0 0 24 24">
            <path d="M4 13h3l9 5V6l-9 5H4v2Z" />
            <path d="M7 13v5a2 2 0 0 0 2 2h1" />
            <path d="M18 9.5a4 4 0 0 1 0 5" />
            <path d="M20.5 7a8 8 0 0 1 0 10" />
          </svg>
          <svg v-else-if="item.icon === 'bell'" viewBox="0 0 24 24">
            <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
            <path d="M10 21h4" />
          </svg>
          <svg v-else viewBox="0 0 24 24">
            <path d="M4 7h16" />
            <path d="M4 12h16" />
            <path d="M4 17h16" />
          </svg>
        </span>
        <span v-if="!collapsed" class="admin-sidebar__label">{{ item.label }}</span>
      </component>
    </nav>

    <div v-if="!collapsed" class="admin-sidebar__footer">v2.4.0 管理后台</div>
  </aside>
</template>

<script>
import { ADMIN_NAV_ITEMS } from '@/constants/admin-navigation'

export default {
  name: 'AdminSidebar',
  props: {
    activeKey: {
      type: String,
      default: 'home',
    },
    mobileOpen: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    commercialId: {
      type: String,
      default: '',
    },
  },
  computed: {
    items() {
      const isAdmin = String(this.commercialId) === '1'
      return ADMIN_NAV_ITEMS.filter(item => !item.adminOnly || isAdmin)
    },
  },
  methods: {
    navItemAttrs(item) {
      return item.href ? { href: item.href } : { to: item.route }
    },
  },
}
</script>

<style scoped>
.admin-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 60;
  width: 320px;
  display: flex;
  flex-direction: column;
  background: #101a33;
  color: #d5def5;
  box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.06);
}

.admin-sidebar.is-collapsed {
  width: 96px;
}

.admin-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 104px;
  padding: 0 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.admin-sidebar.is-collapsed .admin-sidebar__brand {
  justify-content: center;
  padding: 0 12px;
}

.admin-sidebar__brand-mark {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: linear-gradient(180deg, #3a7bff 0%, #2f5fe4 100%);
  box-shadow: 0 12px 24px rgba(33, 84, 221, 0.35);
}

.admin-sidebar__brand-play {
  width: 0;
  height: 0;
  margin-left: 2px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 12px solid #fff;
}

.admin-sidebar__brand-title {
  color: #fff;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.admin-sidebar__nav {
  flex: 1;
  padding: 26px 20px;
  overflow-y: auto;
}

.admin-sidebar.is-collapsed .admin-sidebar__nav {
  padding-left: 12px;
  padding-right: 12px;
}

.admin-sidebar__item {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 60px;
  padding: 0 20px;
  border-radius: 16px;
  color: #9eacd0;
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.admin-sidebar.is-collapsed .admin-sidebar__item {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

.admin-sidebar__item + .admin-sidebar__item {
  margin-top: 10px;
}

.admin-sidebar__item:hover {
  color: #f4f7ff;
  background: rgba(70, 98, 170, 0.28);
}

.admin-sidebar__item.is-active {
  color: #fff;
  background: linear-gradient(90deg, #2f5fe4 0%, #3a6cea 100%);
  box-shadow: 0 10px 24px rgba(47, 95, 228, 0.24);
}

.admin-sidebar__icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.admin-sidebar.is-collapsed .admin-sidebar__icon {
  width: 28px;
  height: 28px;
}

.admin-sidebar__icon svg {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  stroke-width: 1.8;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.admin-sidebar__label {
  font-size: 16px;
  font-weight: 500;
}

.admin-sidebar__footer {
  padding: 20px 24px 22px;
  color: #9da7c5;
  font-size: 14px;
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: min(320px, 84vw);
    transform: translateX(-100%);
    transition: transform 0.25s ease;
  }

  .admin-sidebar.is-collapsed {
    width: min(320px, 84vw);
  }

  .admin-sidebar.is-open {
    transform: translateX(0);
  }
}
</style>
